<template>
    <div class="border border-radius rounded mt-3 cursor-pointer shadow-sm p-3">
        <div class="d-flex border-top-radius pb-3 px-1 border-bottom mb-3">
            <small class="d-flex flex-1 font-weight-bolder">
                {{name}}
            </small>

            <div class="d-flex">
                <small v-if="type === 'Private'" class="rounded d-flex justify-content-center font-weight-bolder bg-somewhat-light-red" style="width: 3rem; color: #ff84a1;">
                    {{type}}
                </small>

                <small v-else class="rounded d-flex justify-content-center font-weight-bolder bg-somewhat-light-skyler" style="width: 3rem; color: #9ab5ff;">
                    {{type}}
                </small>
            </div>
        </div>

        <div class="d-flex justify-content-between">
            <div class="text-center flex-1 p-2">
                <small class="d-block font-weight-bold">
                    <span><i-age></i-age> {{t('Age')}}</span>
                </small>

                <small>
                    {{age}}
                </small>
            </div>

            <div class="mx-2 border align-self-center" style="height: 3rem;"></div>

            <div class="text-center flex-1 p-2">
                <small class="d-block font-weight-bolder">
                    <span><i-height></i-height> {{t('Height')}}</span>
                </small>

                <small>
                    {{height}}
                </small>
            </div>

            <div class="mx-2 border align-self-center" style="height: 3rem;"></div>

            <div class="text-center flex-1 p-2">
                <small class="d-block font-weight-bold">
                    <span><i-weight></i-weight> {{t('Weight')}}</span>
                </small>

                <small>
                    {{weight}}
                </small>
            </div>
        </div>
    </div>
</template>

<script>
    import IHeight from "../Icons/IHeight";
    import IWeight from "../Icons/IWeight";
    import IAge from "../Icons/IAge";

    export default {
        name: "VaccineCard",
        components: {
            IHeight, IWeight, IAge
        },
        props: {
            name: {
                type: String,
                required: true
            },
            weight: {
                type: [String, Number],
                required: false
            },
            height: {
                type: [String, Number],
                required: false
            },
            age: {
                type: [String, Number],
                required: false
            },
            type: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>

</style>
